export default {
  storageMaterial: {
    results: [],
  },

  storageInstrument: {
    results: [],
  },
}
